import {CloseButtonProps, toast} from "react-toastify";
import {ReactComponent as InfoIcon} from "../../assets/svg/info-cirlce.svg";
import {ReactComponent as ErrorIcon} from "../../assets/svg/circle-error.svg";
import React from "react";

interface IToast {
    content: string | any,
    closeButton?: boolean | ((props: CloseButtonProps) => React.ReactNode) | React.ReactElement<CloseButtonProps, string | React.JSXElementConstructor<any>>,
    autoClose?: number,
    leftButtonOnClick?: () => {},
    rightButtonOnClick?: () => {}
}

export class IframeToast {
    static info(props: IToast) {
        toast.info(
            <div>
                {props.content}
            </div>,
            {
                className: "bg-[#383E45] text-[#FFFFFFD9]",
                position: "top-center",
                autoClose: props.autoClose? props.autoClose : 3000,
                closeOnClick: true,
                pauseOnHover: true,
                icon: InfoIcon,
                draggable: false,
                progress: undefined,
                closeButton: props.closeButton? props.closeButton : false,
                hideProgressBar: true
            }
        )
    }

    static error(props: IToast) {
        toast.error(
            <div>
                {props.content}
            </div>,
            {
                className: "border border-[#FF4D4F] bg-[#68373B] text-[#FFFFFFD9]",
                position: "top-center",
                autoClose: props.autoClose ? props.autoClose : 3000,
                closeOnClick: true,
                pauseOnHover: true,
                icon: ErrorIcon,
                draggable: false,
                progress: undefined,
                closeButton: props.closeButton ? props.closeButton : false,
                hideProgressBar: true
            }
        )
    }

}
